module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"thankYou":"Thank you for your order!","continueShopping":"Continue shopping"},"de":{"thankYou":"Vielen Dank für Ihre Bestellung!","continueShopping":"Weiter einkaufen"}}')
  delete Component.options._Ctor
}
